import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TestimonialsBottom() {
  const testimonials = [{
    initials: 'CR',
    name: 'Cecilia R.',
    location: 'Medellín',
    type: 'MegaPack IA + AI OS',
    quote: 'El Workflow de Propuestas me salvó el negocio. Antes tardaba 2 días en armar una propuesta. Ahora la tengo en 20 minutos y mis clientes dicen que es la más profesional que recibieron.'
  }, {
    initials: 'RM',
    name: 'Roberto M.',
    location: 'Buenos Aires',
    type: 'Emprendedor Digital',
    quote: 'Con el sistema de contenido del Tomo 4 y el Bono 5 pasé de publicar 1 vez por semana a publicar todos los días. Mi comunidad creció 300% en 60 días.'
  }, {
    initials: 'SC',
    name: 'Sofía C.',
    location: 'Ciudad de México',
    type: 'Freelancer',
    quote: 'Mis clientes no saben que uso IA. Solo saben que entrego más rápido, con mejor calidad y que nunca me trabo en un correo difícil. El Bono 4 es oro puro.'
  }, {
    initials: 'PA',
    name: 'Pablo A.',
    location: 'Santiago de Chile',
    type: 'Consultor',
    quote: 'El Protocolo Anti-Alucinaciones del Bono 3 debería ser obligatorio para cualquiera que use IA en trabajo profesional. Evité varios errores graves frente a clientes.'
  }];
  return <section className="py-20 px-4" data-id="element-297">
      <div className="max-w-6xl mx-auto" data-id="element-298">
        <div className="text-center mb-12" data-id="element-299">
          <h2 className="text-3xl font-heading font-bold text-white" data-id="element-300">
            ❤️ MÁS PERSONAS QUE YA LO TIENEN
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-301">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} className="bg-surface border border-border rounded-2xl p-6" data-id="element-302">
              <div className="flex items-start justify-between mb-4" data-id="element-303">
                <div className="flex items-center gap-4" data-id="element-304">
                  <div className="w-12 h-12 rounded-full bg-brand/10 text-brand flex items-center justify-center font-bold text-lg shrink-0" data-id="element-305">
                    {t.initials}
                  </div>
                  <div data-id="element-306">
                    <div className="font-bold text-white flex items-center gap-2" data-id="element-307">
                      {t.name}
                      <span className="text-xs font-normal text-muted bg-background px-2 py-0.5 rounded-full" data-id="element-308">
                        📍 {t.location}
                      </span>
                    </div>
                    <div className="text-sm text-brand" data-id="element-309">{t.type}</div>
                  </div>
                </div>
              </div>
              <div className="flex gap-1 mb-3" data-id="element-310">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} className="fill-accent text-accent" data-id="element-311" />)}
              </div>
              <p className="text-gray-300 italic" data-id="element-312">"{t.quote}"</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}